import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { Tab, tabTypeMap } from '../../../model/types';
import { grispiNewsSubscribeToTickets } from '../../../services/grispi-news/grispi-news-services';
import { useGrispiNewsStore, useTabStore } from '../../../store/RootStoreContext';
import { getTabId } from '../../../utils/tabId';
const getTabKeysString = (tabs: Tab[]) =>
    tabs
        .filter((tab) => tab.type === tabTypeMap.TICKET && !tab.key.startsWith('newTicket'))
        .map(({ key }) => key)
        .join(',');
const GrispiNewsSubscribeTicketTabsController = () => {
    const { tabs } = useTabStore();
    const { isGrispiNewsApiAlive } = useGrispiNewsStore();
    const ticketKeys = useMemo(() => getTabKeysString(tabs), [tabs]);

    useEffect(() => {
        const timeOut = setTimeout(() => {
            if (ticketKeys && isGrispiNewsApiAlive) {
                const subscribeToTickets = async () => {
                    try {
                        await grispiNewsSubscribeToTickets({
                            tabId: getTabId(),
                            ticketKeys
                        });
                    } catch (error) {
                        console.log(
                            'Grispi news subscribe to tickets error: ',
                            error?.message ?? error?.request?.response ?? error
                        );
                    }
                    console.log(`Grispi news subscribe to ${ticketKeys} successfully!`);
                };
                subscribeToTickets();
            }
        });
        return () => clearTimeout(timeOut);
    }, [isGrispiNewsApiAlive, ticketKeys]);
    return null;
};

export default observer(GrispiNewsSubscribeTicketTabsController);
